module.exports = __webpack_public_path__ + "static/media/tablet_communities.ca9f424c.jpg";